<div class="app-default-layout">
  <app-header></app-header>
  <div class="sidebar__overlay" (click)="closeMobileMenu()"></div>
  <div class="layout__wrapper">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>
<app-auth-page></app-auth-page>
